interface Response {
  response_meta: ResponseMeta
}

interface ResponseMeta {
  call_id: string
  compiler_type: string
  compiler_version: string
  correlation_id: string
  engine_id: string
  parameterset_version_id: string
  process_time: number
  request_timestamp: string
  service_id: string
  source_hash: string
  system: string
  version: string
  version_id: string
}

const bodyData = {
  request_data: {},
  request_meta: {},
}

export const fetchValidationData = async (id: string): Promise<Response> => {
  return await fetch(`https://excel.uat.us.coherent.global/agilno/api/v3/public/version/${id}`, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(bodyData),
  }).then((response) => {
    return response.json()
  })
}

